import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import HeroTitle from "./sections/HeroTitle";
import ProjectMilestones from "./sections/ProjectMilestones";
import ReadyToSecureYourAssets from "./sections/ReadyToSecureYourAssets";
import NewsSection from "./sections/NewsSection";
import BookYourLavalService from "./sections/BookYourLavalService";
import MultiColumnFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <HeroTitle />
      <ProjectMilestones />
      <NewsSection />
      <BookYourLavalService />
      <ReadyToSecureYourAssets />
      <MultiColumnFooter />
    </div>;
}